// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { kpiFormulaId } from './KpiFormula';
import { fermentationProtocolId } from './FermentationProtocol';
import { fermentationTimepointId } from './FermentationTimepoint';
import { z } from 'zod';
export const kpiValueId = (z.string());
export const kpiValue = z.object({
    id: kpiValueId,
    fermentation_id: fermentationId,
    effective_time_s: z.string(),
    value: z.string().nullable(),
    is_valid: z.boolean().nullable(),
    error_message: z.string().nullable(),
    computed_at: z.date().nullable(),
    inputs_hash: z.string().nullable(),
    formula_id: kpiFormulaId,
    parameter_values: z.record(z.union([z.number(), z.literal("N/A")])).nullable(),
    protocol_id: fermentationProtocolId.nullable(),
    timepoint_id: fermentationTimepointId.nullable(),
});
export const kpiValueInitializer = z.object({
    id: kpiValueId.optional(),
    fermentation_id: fermentationId,
    effective_time_s: z.string(),
    value: z.string().optional().nullable(),
    is_valid: z.boolean().optional().nullable(),
    error_message: z.string().optional().nullable(),
    computed_at: z.date().optional().nullable(),
    inputs_hash: z.string().optional().nullable(),
    formula_id: kpiFormulaId,
    parameter_values: z.record(z.union([z.number(), z.literal("N/A")])).optional().nullable(),
    protocol_id: fermentationProtocolId.optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
});
export const kpiValueMutator = z.object({
    id: kpiValueId.optional(),
    fermentation_id: fermentationId.optional(),
    effective_time_s: z.string().optional(),
    value: z.string().optional().nullable(),
    is_valid: z.boolean().optional().nullable(),
    error_message: z.string().optional().nullable(),
    computed_at: z.date().optional().nullable(),
    inputs_hash: z.string().optional().nullable(),
    formula_id: kpiFormulaId.optional(),
    parameter_values: z.record(z.union([z.number(), z.literal("N/A")])).optional().nullable(),
    protocol_id: fermentationProtocolId.optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
});
//# sourceMappingURL=KpiValue.js.map